import http from 'hub-http/clients/apiClient';
export const fetchCRMObjectsById = async objectTypeId => {
  const objects = await http.get(`crm-objects/v1/objects/${objectTypeId}/paged`);
  return objects;
};